import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/core/services/account.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { StorageService } from 'src/app/core/services/storage.service';
import { ADPResourceService } from 'digital-core';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { dashboardRouteWithSlash } from 'src/app/route-constants';
@Component({
  selector: 'pgh-text-message',
  templateUrl: './text-message.component.html',
  styleUrls: ['./text-message.component.scss']
})
export class TextMessageComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Input() isOnboardingFlow?: boolean = false;
  @Input() isAdditionalDeviceFlow?: boolean = false;
  @Input() phoneNumber: any;
  private device?: DeviceDto;
  public timerDisplay: any;
  public isResendClicked: boolean = false;
  public isTimerVisible: boolean = false;
  public isTechSupportVisible: boolean = false;
  public isDesktopView:boolean = false;
  public resendCount: number = 0;
  public displayPhoneNumber: string = '';

  private subscriptions: Subscription[] = [];

  public textMessageImageUrl:string='';
  public textMessageImageAlt:string='';
  public textMessageTechSupportRepImageUrl:string='';
  public textMessageTechSupportRepImageAlt:string='';

  constructor(
    private router: Router,
    private accountService: AccountService,
    private utilityServce: UtilityService,
    private storageService: StorageService,
    private resourceService: ADPResourceService,
    public dialog: MatDialog
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDesktopView = window.innerWidth >= 768;
  }

  ngOnInit(): void {

    this.device = this.storageService.getSession<DeviceDto>("NewUserDevice");  //get the new device from storage
    //try to send the text on init
    this.sendTextMessage(this.device?.id, this.device?.inventoryId, this.phoneNumber);

    this.displayPhoneNumber = this.phoneNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');

    this.textMessageImageUrl = this.resourceService.getPortalImage('Global_Onboarding_TextMessage_Image').ImageURL;
    this.textMessageImageAlt = this.resourceService.getPortalImage('Global_Onboarding_TextMessage_Image').Caption;

    this.textMessageTechSupportRepImageUrl = this.resourceService.getPortalImage('Global_Onboarding_TextMesssage_TechSupportRep').ImageURL;
    this.textMessageTechSupportRepImageAlt = this.resourceService.getPortalImage('Global_Onboarding_TextMesssage_TechSupportRep').Caption;

    this.isDesktopView = this.isUserUsingDesktop();

  }

  reSend(): void{
    this.sendTextMessage(this.device?.id ,this.device?.inventoryId, this.phoneNumber);
    this.isResendClicked = true;
    this.isTimerVisible = true;
    this.resendCount += 1;

    if(this.resendCount === 3){
      //show tech support
      this.isTechSupportVisible = true;
    }else{
      // show timer
      this.timer(1);
    }
  }

  next(): void {
    this.nextEvent.emit('next');
  }

  goHome(): void {
    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }

  addAnotherDevice(): void{
    this.router.navigate(['additional-device-selection'],{ queryParams: { isOnboardingFlow: 'true', isAdditionalDeviceFlow: 'true'}});
  }

  //send the text message to user for device test
  sendTextMessage(deviceId: number, deviceInventoryId: number, phoneNumber: string): void {
    this.accountService.registerInvitationToDevice(deviceId, deviceInventoryId, true, this.utilityServce.getPhoneNumberForTwilio(phoneNumber)).subscribe(res => {
    });
  }

  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 30;
    let textSec: any = "0";
    let statSec: number = 30;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.timerDisplay = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        console.log("finished");
        this.isTimerVisible = false;
        clearInterval(timer);
      }
    }, 1000);
  }

  isUserUsingDesktop() : boolean {

    // User agent string method
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Screen resolution method
    if (!isMobile) {
        let screenWidth = window.screen.width;
        let screenHeight = window.screen.height;
        isMobile = (screenWidth < 768 || screenHeight < 768);
    }

    // Touch events method
    if (!isMobile) {
        isMobile = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
    }

    // CSS media queries method
    if (!isMobile) {
        let bodyElement = document.getElementsByTagName('body')[0];
        isMobile = window.getComputedStyle(bodyElement).getPropertyValue('content').indexOf('mobile') !== -1;
    }

    return !isMobile

}



}
